var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgView = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 11,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3293E6",
  fillRule: "evenodd",
  d: "M8 0C4.364 0 1.258 2.262 0 5.455c1.258 3.192 4.364 5.454 8 5.454s6.742-2.262 8-5.454C14.742 2.262 11.636 0 8 0m0 9.09a3.64 3.64 0 0 1-3.636-3.635A3.64 3.64 0 0 1 8 1.818a3.64 3.64 0 0 1 3.636 3.637A3.64 3.64 0 0 1 8 9.09m0-5.817a2.18 2.18 0 0 0-2.182 2.182c0 1.207.975 2.181 2.182 2.181a2.18 2.18 0 0 0 2.182-2.181A2.18 2.18 0 0 0 8 3.273",
  clipRule: "evenodd"
})));
export { SvgView as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvdmlldy43NTNjYjk2Yi5zdmciOw==";